<template>
    <b-modal :title="this.$route.name" hide-footer size="lg" v-model="largeModal" @ok="largeModal = false">
        <form @submit.prevent="updateApplication">
            <div  class="form-group row">
                <label  class="col-sm-3 col-form-label"> নাম</label>
                <div class="col-sm-3">
                    <input name="name" disabled type="text"  v-model="editApplicationForm.name" class="form-control"  placeholder="নাম">
                </div>
                <label class="col-sm-3 col-form-label">জন্ম তারিখ</label>
                <div class="col-sm-3">
                    <input type="date" disabled v-model="editApplicationForm.birthday" class="form-control"  placeholder="জন্ম তারিখ">
                </div>
            </div>
            <div  class="form-group row">
                <label  class="col-sm-3 col-form-label">মোবাইল নম্বর</label>
                <div class="col-sm-3">
                    <input type="text" disabled v-model="editApplicationForm.mobile_number" class="form-control" name="mobile_number" placeholder="মোবাইল নম্বর">
                </div>
                <label  class="col-sm-3 col-form-label">এন.আই.ডি নম্বর</label>
                <div class="col-sm-3">
                    <input type="text" disabled v-model="editApplicationForm.nid" class="form-control" name="nid" placeholder="এন.আই.ডি নম্বর">
                </div>
            </div>
            <div  class="form-group row">
                <label  class="col-sm-3 col-form-label">লাইনের ধরন</label>
                <div class="col-sm-3">
                    <select v-validate="'required'" @change="getSelectService()" v-model="editApplicationForm.select_dia"  class="form-control">
                        <option value="">লাইনের ব্যাস</option>
                        <option value="0.5">0.5 ইঞ্চি</option>
                        <option value="0.75">0.75 ইঞ্চি</option>
                        <option value="1.00">1 ইঞ্চি</option>
                        <option value="1.5">1.5 ইঞ্চি</option>
                        <option value="1.75">1.75 ইঞ্চি</option>
                        <option value="1">2 ইঞ্চি</option>
                    </select>
                </div>
                <label  class="col-sm-3 col-form-label">লাইনের কাঠামো</label>
                <div class="col-sm-3">
                    <select @change="serviceCharge()" v-model="editApplicationForm.service_id" name="Diameter" class="form-control">
                        <option value="">লাইনের কাঠামো</option>
                        <option :value="diameter.id" v-for="(diameter,key) in service_list" :key="key">{{diameter.name}}&nbsp;{{diameter.diameter}}ইঞ্চি</option>
                    </select>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">সংযোগ নবায়ন ফি</label>
                <div class="col-sm-3 col-form-label"><b>{{application_fee}}</b></div>
                <label class="col-sm-3 col-form-label">অ্যাডজাস্টমেন্ট</label>
                <div class="col-sm-2 pr-1">
                    <select @change="adjust(question)" v-model="adjustment_type" class="form-control">
                        <option value="">প্রকার</option>
                        <option value="1">অতিরিক্ত ফি</option>
                        <option value="2">কম ফি</option>
                    </select>
                </div>
                <div class="col-sm-1 pl-0">
                    <input  type="number" v-model="question" min="0"  class="form-control">
                </div>
            </div>
            <div class="form-group row">
                <div class="col-sm-6"></div>
                <div style="border-top:1px solid #bbc3ca" class="col-sm-6">
                    <div class="row mt-1">
                        <div class="col-sm-6 mb-1">অ্যাডজাস্টমেন্ট</div><div class="col-sm-6">: <b>{{editApplicationForm.adjustment}}</b></div>
                        <div class="col-sm-6 mb-1">মোট নবায়ন ফি</div><div class="col-sm-6">: <b>{{editApplicationForm.fee}}</b></div>
                        <div class="col-sm-6 mb-1">মাসিক বিল</div><div class="col-sm-6">: <b>{{editApplicationForm.monthly_bill}}</b></div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="form-group row">
                <div class="col-sm-12">
                    <input type="submit" value="submit" v-if="!addApplicationLoader"  class="btn btn-primary pull-right">
                    <button v-if="! addApplicationLoader" @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                    <button v-if="addApplicationLoader" class="btn btn-primary pull-right" type="button" disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Submitting...
                    </button>
                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>
    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);
    import { mapState,mapGetters } from "vuex"
    import { VueEditor } from 'vue2-editor'
    import axios from 'axios'
    import { UPDATE_MARKET_APPLICATION} from "@/store/action.type"
    export default {
        name: "editApplicationModal",
        data(){
            return{
                question:0,
                servererrors:'',
                largeModal:false,
                addLoader: false,
                addApplicationLoader:false,
                index:null,
                application_fee:0,
                user:{
                    id:'',
                    name:'',
                    nid:'',
                    mobile_number:'',
                    birthday:''
                },
                editApplicationForm:{
                    id:'',
                    nid:'',
                    name:'',
                    approve_date:'',
                    price:'',
                    fee:0,
                    service_id:'',
                    adjustment:0,
                    monthly_bill:0,
                    select_dia:'',
                    adjustment_type:'',
                },
                adjustment_type:'',
                service_list:[],
                diameter_list:[],
            }
        },

        computed:{
            ...mapGetters(['modal','wards'])
        },
        watch:{
            question: function (){
                this.editApplicationForm.adjustment = parseInt(this.question)
                this.adjust(parseInt(this.question))
            }
        },
        methods:{
            openModal(application,index){
                this.largeModal = true
                this.question = 0
                this.index = index
                this.editApplicationForm.id = application.id
                this.editApplicationForm.name = application.user.name
                this.editApplicationForm.birthday = application.user.birthday
                this.editApplicationForm.select_dia = application.service.diameter
                this.editApplicationForm.service_id = application.service.id
                this.editApplicationForm.nid = application.user.nid
                this.editApplicationForm.ward_no = application.ward_no
                this.editApplicationForm.volume = application.volume
                this.editApplicationForm.price = application.price
                this.editApplicationForm.account_no = application.account_no
                this.application_fee = application.service.update_fee
                this.editApplicationForm.monthly_bill = application.service.price
                this.editApplicationForm.fee = application.service.update_fee
                this.servererrors = ""
                //console.log(application)
                this.getSelectService(this.editApplicationForm.select_dia)
            },
            adjust(adjustment = 0){
                this.editApplicationForm.adjustment =  adjustment
                //alert(this.editApplicationForm.adjustment)
                var self = this
                //alert(adjustment)
                if(self.adjustment_type){
                    if(self.adjustment_type == 1){
                        self.editApplicationForm.adjustment =  parseInt(self.editApplicationForm.adjustment)
                        self.editApplicationForm.adjustment_type = 'positive'
                    }
                    else if(self.adjustment_type == 2){
                        self.editApplicationForm.adjustment =  parseInt(-self.editApplicationForm.adjustment)
                        self.editApplicationForm.adjustment_type = 'negative'
                    }
                }
                else{
                    self.editApplicationForm.adjustment =  0
                    self.editApplicationForm.adjustment_type = 'positive'
                }
                self.editApplicationForm.fee = self.application_fee + self.editApplicationForm.adjustment
            },
            getSelectService(select_dia){
                axios.get('api/project-all').then(response=>{
                    this.diameter_list = response.data
                    this.diameter_list.forEach(element=>{
                        if(element.diameter == parseFloat(select_dia)){
                            this.service_list.push(element)
                        }
                    })
                })
            },
            serviceCharge(){
                var self = this
                //console.log(this.diameter_list)
                this.diameter_list.forEach(element=>{
                    if(element.id == self.editApplicationForm.service_id){
                        //alert(element.price)
                        self.application_fee = element.update_fee
                        self.editApplicationForm.fee = self.application_fee + self.editApplicationForm.adjustment
                        self.editApplicationForm.monthly_bill = element.price
                    }
                })
            },
            errorClear(fields)
            {
                delete this.servererrors[fields];
            },
            close(){
                this.largeModal = false
            },
            updateApplication(){
                this.$validator.validateAll().then( result =>{
                    if(result){
                        var data = this.editApplicationForm
                        var index = this.index
                        this.addApplicationLoader = true;
                        this.$store.dispatch('MALIKANA_PORIBORTON',{data,index})
                        .then(response=>{
                            this.addApplicationLoader = false;
                            this.largeModal = false
                        })
                        .catch(error=>{
                            //console.log(error)
                            this.addApplicationLoader=false;
                            this.servererrors = error.response.data.errors;
                            //console.log(this.servererrors)
                        });
                    }

                })
            }
        },
    }

</script>

<style scoped>

</style>